import React,{useEffect} from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import Router, Routes, and Route
import Home from './Components/Home/Home';

import { useLocation } from "react-router-dom";
import Footer from './Components/Footer/Footer'
import AirlinePartner from './Components/AirlinePartner/AirlinePartner'
import Header from "./Components/Header/Header";
import Destination from "./Components/Destination/Destination";
import BusinessFlight from "./Components/BusinessFlight/BusinessFlight";
import HolidayOffer from "./Components/HolidayOffer/HolidayOffer";
import DestinationDetail from "./Components/Destination/DestinationDetail";
import AirlinesDetail from "./Components/AirlinePartner/AirlinesDetail";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./Components/Terms&Conditions/Terms&Conditions";
import Thankyou from "./Components/Thankyou/Thankyou";
import FlightResult from "./Components/FlightResult/FlightResult";
import Signin from "./Components/Signin/Signin";
import ExcelUpload from "./Components/Upload/ExcelUploader";
import Chat from "./Components/Chatbox/Chat"

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'  
    });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} /> 
        
        <Route path="/airline" element={<AirlinePartner />} /> 
        <Route path="/airlines/:id" element={<AirlinesDetail />} /> 
        <Route path="/destination" element={<Destination />} /> 
        <Route path="/destination/:id" element={<DestinationDetail />} />
        <Route path="/holiday-offer" element={<HolidayOffer />} /> 
        
        <Route path="/about-us" element={<About />} /> 
        <Route path="/flight-result" element={<FlightResult/>} /> 
        <Route path="/thankyou" element={<Thankyou />} /> 
        <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> 
        <Route path="/contact-us" element={<Contact />} /> 
        <Route path="/admin-login" element={<Signin />} /> 
        <Route path="/upload-flights" element={<ExcelUpload />} /> 
        <Route path="/business-flight" element={<BusinessFlight />} /> 
      </Routes>
   <Chat/>
     <Footer/>
    </Router>
  );
}

export default App;
